var tdBlogIndex = {
    init: function() {

        // position the call us block after the second blog tile
        jQuery('.blog-posts article:nth-child(2)').after(jQuery('.call-us-block:first').removeClass('fullwidth').show());

    },
}

export default tdBlogIndex;